import { render, staticRenderFns } from "./MarketOffline.vue?vue&type=template&id=76d854be&scoped=true&"
import script from "./MarketOffline.vue?vue&type=script&lang=js&"
export * from "./MarketOffline.vue?vue&type=script&lang=js&"
import style0 from "./MarketOffline.vue?vue&type=style&index=0&id=76d854be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d854be",
  null
  
)

export default component.exports